export enum TextType {
  operator,
  number,
  paren,
  phrase,
  invalid,
}
